import { render, staticRenderFns } from "./MenuLivraison.vue?vue&type=template&id=6631cc79&scoped=true&"
import script from "./MenuLivraison.vue?vue&type=script&lang=js&"
export * from "./MenuLivraison.vue?vue&type=script&lang=js&"
import style0 from "./MenuLivraison.vue?vue&type=style&index=0&id=6631cc79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631cc79",
  null
  
)

export default component.exports